import React from 'react';
import { RotatingLines } from 'react-loader-spinner';

const PaymentDetails = ({ isLoading, enablePlaceOrder, handleSteps, handlePaymentInput, handlePayment, paymentSettings, paymentSelectedInput }: any) => {

  const items = [
    {
      name: 'Cash',
      description: 'Cash on delivery',
      value: 10,
      checked: '',
      imageUrl: require('./../../../../../assets/img/cash.png'),
      show: paymentSettings?.result?.items?.MarketplaceSettings?.EnableForParcelCOD,

    },
    {
      name: 'Online',
      description: 'Payment gateway',
      value: 20,
      checked: 'checked',
      imageUrl: require('./../../../../../assets/img/ccAvenue.png'),
      show: paymentSettings?.result?.items?.MarketplaceSettings?.EnableForParcelOnline,
    },
    {
      name: 'Wallet',
      description: 'Wallet',
      value: 40,
      checked: '',
      imageUrl: require('./../../../../../assets/img/wallet.png'),
      show: paymentSettings?.result?.items?.MarketplaceSettings?.EnableForWallet,
    },
  ];


  return (
    <div className="flex flex-col justify-center items-center h-[450px]">
      <div className="overflow-auto  m-3 w-full max-w-sm h-full">
        <div className="flex flex-col justify-center items-start p-4 space-y-5">
          <div className="text-lg font-semibold">Payment Details</div>
          <div className="text-sm font-normal font-semibold p-2">Payment Method</div>

          <div className="grid grid-cols-2 gap-4 w-full">
            {items?.map((item: any, index: any) =>
              item.show && (
                <div key={index} className="flex flex-row w-full items-center">
                  <div>
                    <input
                      name={item?.name}
                      type="radio"
                      checked={paymentSelectedInput == String(item?.name)}
                      className="mx-3 rounded bg-opacity-0 cursor-pointer transform scale-125"
                      onChange={(event: any) => handlePaymentInput(event, item)}
                      value={item?.name}
                    />

                  </div>
                  <div className='text-sm font-medium text-gray-600'>
                    {item?.name}
                  </div>

                </div>
              )
            )}
          </div>

          <div className="w-full flex flex-col items-center space-y-3">

            {paymentSelectedInput == "Cash" ? (
              <button
                onClick={handlePayment}
                disabled={!enablePlaceOrder || isLoading}
                className={`w-full flex items-center justify-center px-4 py-2 text-sm rounded ${isLoading
                  ? "bg-primary text-light bg-opacity-80"
                  : enablePlaceOrder
                    ? "bg-primary text-light cursor-pointer"
                    : "bg-gray-400 text-gray-200 cursor-not-allowed"
                  }`}
              >
                Place Order
                {isLoading && (
                  <div className="ml-2">
                    <RotatingLines
                      visible={true}
                      width="16"
                      strokeColor="#fff"
                      strokeWidth="6"
                      animationDuration="0.75"
                      ariaLabel="rotating-lines-loading"
                    />
                  </div>
                )}
              </button>
            ) : (
              <button
                onClick={handlePayment}
                disabled={!enablePlaceOrder || isLoading}
                className={`w-full flex items-center justify-center px-4 py-2 text-sm rounded ${isLoading
                  ? "bg-primary text-light bg-opacity-80"
                  : enablePlaceOrder
                    ? "bg-primary text-light cursor-pointer"
                    : "bg-gray-400 text-gray-200 cursor-not-allowed"
                  }`}
              >
                Make a Payment
                {isLoading && (
                  <div className="ml-2">
                    <RotatingLines
                      visible={true}
                      width="16"
                      strokeColor="#fff"
                      strokeWidth="6"
                      animationDuration="0.75"
                      ariaLabel="rotating-lines-loading"
                    />
                  </div>
                )}
              </button>
            )}
            <button
              onClick={handleSteps}
              className="w-full px-4 py-2 bg-primary text-light text-sm rounded"
            >
              Book Later
            </button>

          </div>
        </div>
      </div>
    </div>

  );
};

export default PaymentDetails;
